<template minapp="mpx" xlang="wxml">
  <view class="top-condition-bar">
    <block wx:if="{{!isTransfer}}">
      <view class="top-condition-bar-item" bindtap="clickFilter('tickets')" wx:class="{{{select: ticketsSelected}}}">只看有票</view>
      <view class="top-condition-bar-item" bindtap="clickFilter('speed')" wx:class="{{{select: speedSelected}}}">高铁动车</view>
    </block>
    <block wx:else>
      <view class="top-condition-bar-item" bindtap="clickFilter('transferType')" wx:class="{{{select: transferTypeSelected}}}">同站换乘</view>
      <view class="top-condition-bar-item" bindtap="clickFilter('transferTrain')" wx:class="{{{select: transferGTrainSelected}}}">高铁中转</view>
    </block>
    <!-- <view class="top-condition-bar-item" bindtap="clickFilter('preferred_tickets')">学生票</view> -->
    <view class="split-line" wx:if="{{showSplitLine}}"></view>
    <view class="top-condition-bar-item" wx:for="{{from_station_list}}" bindtap="clickFilter('from', item)" wx:class="{{{select: fromSelected.includes(item)}}}">{{item}}</view>
    <view class="split-line" wx:if="{{showSplitLine}}"></view>
    <view class="top-condition-bar-item" wx:for="{{to_station_list}}" bindtap="clickFilter('to', item)" wx:class="{{{select: toSelected.includes(item)}}}">{{item}}</view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { setStorage } from '@/utils/storage'
  import { STORAGE_LIST_SEARCH_QUERY, STORATE_CONDITION_SEARCH_QUERY } from '@/utils/train-storage'
  import { getStorage } from '../../../../utils/storage'

  createComponent({
    props: {
      trainListSearchQuery: {
        type: Object,
        value: {}
      },
      unionType: {
        type: Number,
        value: 0
      }
    },
    data: {
      condition: {
        train_type_code: [],
        start_time_list: [],
        end_time_list: [],
        from_city_match: [],
        to_city_match: [],
        passenger_type: '',
        preferred_tickets: '',
        is_fxh: '',
        is_zndc: '',
        is_quiet: '0'
      }
    },
    mounted() {
      const _condition = getStorage(STORATE_CONDITION_SEARCH_QUERY)
      !this.isScramble &&
        _condition &&
        Object.keys(_condition).length &&
        (this.condition = { ..._condition })
    },
    computed: {
      ...store.mapState({
        from_station_list: 'train.trainListInfo.from_station_list',
        to_station_list: 'train.trainListInfo.to_station_list'
      }),
      fromSelected() {
        return this.trainListSearchQuery?.from_city_match?.length ? this.trainListSearchQuery?.from_city_match?.split(',') : []
      },
      toSelected() {
        return this.trainListSearchQuery?.to_city_match?.length ? this.trainListSearchQuery?.to_city_match?.split(',') : []
      },
      ticketsSelected() {
        return this.trainListSearchQuery?.preferred_tickets === '1'
      },
      transferTypeSelected() {
        return +this.trainListSearchQuery?.transfer_station_type === 1
      },
      speedSelected() {
        const speed = this.trainListSearchQuery.train_type_code
        return speed?.includes('G') && speed?.includes('D') && speed?.includes('C')
      },
      transferGTrainSelected() {
        const transfer = this.trainListSearchQuery.train_type_code
        return transfer?.includes('GG')
      },
      showSplitLine() {
        return this.from_station_list?.length || this.to_station_list?.length
      },
      isTransfer() {
        return !!this.unionType
      }
    },
    methods: {
      clickFilter(type, item) {
        const trainListSearchQuery = { ...this.trainListSearchQuery }
        // let condition = {}
        switch (type) {
          case 'tickets':
            trainListSearchQuery.preferred_tickets = this.ticketsSelected ? '0' : '1'
            this.condition.preferred_tickets = this.ticketsSelected ? '0' : '1'
            break
          case 'speed':
            trainListSearchQuery.train_type_code = trainListSearchQuery.train_type_code?.includes('G'&&'D'&&'C') ? '' : 'G,D,C'
            this.condition.train_type_code = trainListSearchQuery.train_type_code?.includes('G'&&'D'&&'C') ? ['G','D','C'] : []
            break
          case 'from':
            let fromList = [...this.fromSelected]
            fromList?.includes(item) ? fromList = fromList?.filter(city => city !== item) : fromList.push(item)
            this.condition.from_city_match = fromList
            trainListSearchQuery.from_city_match = fromList.join()
            trainListSearchQuery.from_prefect_match = fromList?.length ? '1' : '0'
            break
          case 'to':
            let toList = [...this.toSelected]
            toList?.includes(item) ? toList = toList?.filter(city => city !== item) : toList.push(item)
            this.condition.to_city_match = toList
            trainListSearchQuery.to_city_match = toList.join()
            trainListSearchQuery.to_prefect_match = toList?.length ? '1' : '0'
            break
          case 'transferType':
            trainListSearchQuery.transfer_station_type = this.transferTypeSelected ? 0 : 1
            this.condition.transfer_station_type = this.transferTypeSelected ? 0 : 1
            break
          case 'transferTrain':
            trainListSearchQuery.train_type_code =  this.transferGTrainSelected ? '' : 'GG'
              this.condition.train_type_code = trainListSearchQuery.train_type_code?.includes('GG') ? ['GG'] : []
            break
        }
        
        const newTrainListSearchQuery = {
          ...trainListSearchQuery,
        }
        setStorage({ key: STORATE_CONDITION_SEARCH_QUERY, data: this.condition})
        setStorage({ key: STORAGE_LIST_SEARCH_QUERY, data: newTrainListSearchQuery })
        this.parentDataChange({
          detail: {
            key: 'trainListSearchQuery',
            value: newTrainListSearchQuery
          }
        })
        this.getTrainListFunc()
      },
      parentDataChange({ detail: params }) {
        this.$trigger('parentDataChange', params)
      },
      getTrainListFunc() {
        this.$trigger('getTrainListFunc')
      },
    }
  })
</script>

<style lang="stylus" scoped>
  .top-condition-bar
    display flex
    flex-direction row
    padding-left 4px
    font-size 12px
    line-height 30px
    padding-bottom 12px
    overflow-x auto
    height 31px 
    white-space nowrap
    &-item
      height 30px
      border 0.5px solid #CCCCCC
      color #666666
      margin-left 8px
      border-radius 6px
      padding 0 10px
      width fit-content
      display flex
      flex-shrink 0
      // overflow hidden
    .select
      color #222222
      font-family PingFangSC-Medium
      border 0.5px solid #FF6400
      position relative
      &::after 
        content ''
        position absolute 
        bottom 0
        right 0
        width 10px
        height 10px
        background url('https://dpubstatic.udache.com/static/dpubimg/QbadIsbSV7H9PID73EIiG.png')
        background-size cover
    .split-line
      display flex
      flex-shrink 0
      margin 5px 0 0 8px
      width 0.5px
      height 20px
      background #CCCCCC
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {}
  }
</script>